
export const mainPathsSegments = {
    faq: 'faq'
};

export const mainPaths = {
    home: '',
    faq: '/' + mainPathsSegments.faq
};
